import { render, staticRenderFns } from "./AdminOrder.vue?vue&type=template&id=c1f350a2&"
import script from "./AdminOrder.vue?vue&type=script&lang=js&"
export * from "./AdminOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports